import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "7",
  fill: "none",
  viewBox: "0 0 8 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "stroke-width": "0",
      d: "M2.734 6a1 1 0 0 0 1.732 0l2.598-4.5A1 1 0 0 0 6.198 0H1a1 1 0 0 0-.866 1.5z"
    }, null, -1)
  ])))
}
export default { render: render }